class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');

    this.form.addEventListener('change', (event) => {
      event.preventDefault();
      this.form.submit();
    });
  }
}
if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
